// extracted by mini-css-extract-plugin
export default {"container":"PPnyJ","searchIcon":"wWF8Q"};